
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"939","height":"808","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M478.24 721.478C501.154 775.538 553.698 808 608.94 808c18.478 0 37.279-3.632 55.371-11.314 72.147-30.597 105.824-113.903 75.198-186.091l-79.664-187.81 208.597-121.41c67.743-39.435 90.689-126.31 51.29-194.061-39.399-67.752-126.264-90.666-194.041-51.295L548.113 159.375l-30.891-72.823c-30.594-72.156-113.524-105.9-186.07-75.208-72.147 30.598-105.826 113.904-75.199 186.091l44.9 105.853L70.557 438.153C2.814 477.498-20.13 563.639 19.267 631.39c26.352 45.285 73.914 71.118 122.794 71.118 24.231 0 49.162-6.773 71.247-19.822l199.278-115.988 65.654 154.78z","fill":"#CE5640"}})])
          )
        }
      }
    